import React from "react"
import PropTypes from "prop-types"

class PriceButton extends React.Component {
  onClick = event => {
    const {x, width} = this.domElement.getBoundingClientRect()
    this.props.onClick(this.props.number, event.clientX - x < width / 2 ? "left" : "right")
  }

  render() {
    const {selected, children, unitsNumber} = this.props
    const className = `shop-reservation__price-button ${selected ? "selected" : ""}`
    return (
      <button className={className} ref={e => this.domElement = e} onClick={this.onClick}>
        {selected && unitsNumber != null && <span className="units-number">{unitsNumber}</span>}
        {children}
      </button>
    )
  }
}

PriceButton.propTypes = {
  onClick: PropTypes.func,
  number: PropTypes.number,
  selected: PropTypes.bool,
  unitsNumber: PropTypes.number,
  children: PropTypes.node
}

export default PriceButton

